import FRApi from './_frApi';
import httpClient from '@/apis/base/httpclient';

class FrColumnListAPI extends FRApi {
  constructor() {
    super();
  }
  controllerName = 'FrColumnLists';

  /**
   * Add and Update multiple
   * nmtuan4 07.06.2022
   */
  addAndUpdateMultiple(param) {
    let request = {
      url: this.getAPIUrl() + '/AddAndUpdateMultiple',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Cập nhật công thức cột
   * dtnga3 (19.09.2022)
   */
  updateFormulaColumn(param) {
    let request = {
      url: this.getAPIUrl() + '/updateFormulaColumn',
      data: param,
    };
    return httpClient.putAsync(request, true);
  }

  /**
   * Cập nhật thiết lập cho danh sách cột
   * dtnga3 (24.03.2023)
   */
  updateMultiple(param) {
    let request = {
      url: this.getAPIUrl() + '/updateMultiple',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Lấy các cột con có trong công thức cột tổng
   * @param {*} param chứa id cột thiết lập
   * dtnga3 (19.09.2022)
   */
  getDetailColumnFormula(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailColumnFormula',
      data: param,
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy các cột con có trong công thức cột tổng (mặc định)
   * @param {*} param chứa id cột thiết lập
   * dtnga3 (19.09.2022)
   */
  getDetailColumnFormulaDefault(param) {
    let request = {
      url: this.getAPIUrl() + '/getDetailColumnFormulaDefault',
      data: param,
    };
    return httpClient.getAsync(request);
  }
}

export default new FrColumnListAPI();
